// you will find all Admin API's here

import mutations from '../general/mutations';
import adminMutations from './mutations';
import { DataService } from '../../../src/config/dataService/dataService';


const state = () => ({
	user: {},
	data: [],
	messages: [],
	loading: false,
	message: '',
});
// declare actions
const actions = {
	// Get All Regex
	async adminLogin({ commit },loginData) {
		try {
			await commit('axiosStart');
            const response = await DataService.post('/Login/Login',loginData);
			if (response.data.status == 1) {
				await commit('axiosSuccess');
				//send back the token
			
			} else {
				await commit('axiosSuccess');
            }
            return response.data
		} catch (err) {
			await commit('axiosError', err);
			return false;
		}
	},
	async getAllUsers({ commit },pageNumber) {
		try {
			await commit('axiosStart');
            const response = await DataService.get(`/user/all?pageNumber=${pageNumber}`);
			if (response.data.status == 1) {
				await commit('axiosSuccess');
				await commit('SET_ALL_USERS',response.data);
				//send back the token
			
			} else {
				await commit('axiosSuccess');
            }
            return response
		} catch (err) {
			await commit('axiosError', err);
			return false;
		}
    },
    async addUser({ commit }, user) {
        try {
            await commit('axiosStart');
            const response = await DataService.post(`/user`, user);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
                //send back the token

            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    async editUser({ commit }, user) {

        try {
            await commit('axiosStart');
            const response = await DataService.put(`/user/${user.id}`, user);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
                //send back the token

            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    async changeUserStatus({ commit }, user) {
        try {
            await commit('axiosStart');
            const response = await DataService.put(`/user/${user.userCode}/change_status/${user.status}`);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
                //send back the token

            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    async resetUserPassword({ commit },userCode) {
		try {
			await commit('axiosStart');
            const response = await DataService.put(`/user/${userCode}/reset_password`);
			if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
				//send back the token
			
			} else {
                await commit('axiosSuccess');
                return false
            }
            
		} catch (err) {
			await commit('axiosError', err);
			return false;
		}
	},
	async adminResetPassword({ commit },loginData) {
		try {
			await commit('axiosStart');
            const response = await DataService.put('/auth/forget_password',loginData);
			if (response.data.status == 1) {
				await commit('axiosSuccess');
				//send back the token
			
			} else {
				await commit('axiosSuccess');
            }
            return response
		} catch (err) {
			await commit('axiosError', err);
			return false;
		}
	},
	async publishChanges({ commit }) {
		try {
			await commit('axiosStart');
            const response = await DataService.get('/setting/publish');
			if (response.data.status == 1) {
				await commit('axiosSuccess');
			} else {
				await commit('axiosSuccess');
            }
            return response
		} catch (err) {
			await commit('axiosError', err);
			return false;
		}
	},
	async setUser({ commit },user) {
		try {
			await commit('SET_USER',user);
            
		} catch (err) {
			await commit('axiosError', err);
			return false;
		}
    },
	async setUsers({ commit },users) {
		try {
			await commit('SET_ALL_USERS',users);
            
		} catch (err) {
			await commit('axiosError', err);
			return false;
		}
    },
    async updateUserProfile({commit,dispatch},userData){
        try {
			await commit('axiosStart');
            const response = await DataService.put('/me/profile',userData);
			if (response.data.status == 1) {
                const userProfile = await DataService.get('/me/profile');
                if (userProfile.status == 200) {
                    await dispatch('setUser',userProfile.data)
                    await commit('axiosSuccess', response.data);
                    return true
                }
				await commit('axiosSuccess');
			} else {
                await commit('axiosError');
                return false
            }
            
		} catch (err) {
			await commit('axiosError', err);
			return false;
        }
    },
    async updateUserAvatar({commit,dispatch},image){
        const body = new FormData();
        body.append("file", image)
        const headers = {
            'Content-Type': 'multipart/form-data'
        }
        try {
			await commit('axiosStart');
            const response = await DataService.put('/me/avatar',body,headers);
			if (response.data.status == 1) {
                const userProfile = await DataService.get('/me/profile');
                if (userProfile.status == 200) {
                    await dispatch('setUser',userProfile.data)
                    await commit('axiosSuccess');
                    return true
                }else{
                    await commit('axiosError');
                    return false
                }
			} else {
                await commit('axiosError');
                return false
            }
            
		} catch (err) {
			await commit('axiosError', err);
			return false;
        }
        
        
    },
    async getMessages({ commit },pageNumber) {
		try {
			await commit('axiosStart');
            const response = await DataService.get(`/inbox?pageNumber=${pageNumber}`);
			if (response.data.status == 1) {
                await commit('axiosSuccess');
                await commit('SET_MESSAGES', response.data);
			} else {
				await commit('axiosError');
            }
            return response
		} catch (err) {
			await commit('axiosError', err);
			return false;
		}
    },
    async readMessage({ commit },id) {
		try {
			await commit('axiosStart');
            const response = await DataService.put(`/inbox/${id}/read`);
			if (response.data.status == 1) {
                await commit('axiosSuccess');
			} else {
				await commit('axiosError');
            }
            return response
		} catch (err) {
			await commit('axiosError', err);
			return false;
		}
    },
    async readAllMessages({ commit }) {
		try {
			await commit('axiosStart');
            const response = await DataService.put(`/inbox/read`);
			if (response.data.status == 1) {
                await commit('axiosSuccess');
			} else {
				await commit('axiosError');
            }
            return response
		} catch (err) {
			await commit('axiosError', err);
			return false;
		}
    },
    async sendReply({ commit },dataToSend) {
		try {
			await commit('axiosStart');
            const response = await DataService.post(`/inbox/${dataToSend.id}/reply`,dataToSend.reply);
			if (response.data.status == 1) {
                await commit('axiosSuccess');
			} else {
				await commit('axiosError');
            }
            return response
		} catch (err) {
			await commit('axiosError', err);
			return false;
		}
    },
    async setMessages({ commit }, messages) {
        try {
            await commit('SET_MESSAGES', messages);
            return true
        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    async getAllLanguages({ commit }) {
        try {
            await commit('axiosStart');
            const response = await DataService.get(`/Settings/GetLanguages`);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                await commit('SET_LANGUAGES', response.data);
                // await commit('SET_PUBLISHED_LANGUAGES', response.data);
                return response
            } else {
                await commit('axiosSuccess');
                return false
            }
        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
	
};
const getters = {
    loggedUser: state =>{
        return state.user
    },
    
}
export default {
	namespaced: false,
	state,
    actions,
    getters,
	mutations:{...adminMutations,...mutations}
};
